export const ADVANCED_BALANCE_TAB_KEYS = {
    USER_TENURE: 'user-tenure',
    OVERDRAFT: 'overdraft',
    ACH: 'ach',
    EMPLOYMENT_TENURE: 'employment-tenure',
    LIMITS: 'limits',
};

export const ADVANCED_BALANCE_TABS = [
    { key: ADVANCED_BALANCE_TAB_KEYS.USER_TENURE, label: 'User Tenure' },
    { key: ADVANCED_BALANCE_TAB_KEYS.OVERDRAFT, label: 'Overdraft & NSF' },
    { key: ADVANCED_BALANCE_TAB_KEYS.ACH, label: 'ACH return' },
    { key: ADVANCED_BALANCE_TAB_KEYS.EMPLOYMENT_TENURE, label: 'Employment Tenure' },
    { key: ADVANCED_BALANCE_TAB_KEYS.LIMITS, label: 'Other' },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
    { value: 'full-time', label: 'Full-time' },
    { value: 'part-time', label: 'Part-time' },
    { value: 'contract', label: 'Contract' },
];

// Timeframe window used by count-based rules (Overdraft & NSF, ACH return) so
// the condition is evaluated over "the last N days/weeks/months" instead of
// over the user's entire history.
export const RULE_TIMEFRAME_UNIT_OPTIONS = [
    { value: 'day', label: 'days' },
    { value: 'week', label: 'weeks' },
    { value: 'month', label: 'months' },
];

export const DEFAULT_RULE_TIMEFRAME = { timeframeValue: 30, timeframeUnit: 'day' };

// Rule types whose condition is evaluated over a rolling timeframe window.
export const TIMEFRAME_RULE_TYPES = ['overdraft', 'ach'];

